import { format } from 'date-fns';
import { TFunction } from 'i18next';

export const formatDateTime = (value?: string | null) => (value ? format(new Date(value), 'yyyy-MM-dd HH:mm') : '–');

export const formatDate = (value?: string | null) => (value ? format(new Date(value), 'yyyy-MM-dd') : '–');

/** Order status as the regular app labels it (orders:SENT_BY_CUSTOMER, ...), else the raw value. */
export const statusLabel = (translate: TFunction, status?: string | null, rejectStatus?: string | null) => {
    if (rejectStatus) {
        return translate(`orders:${rejectStatus.toUpperCase()}`, { defaultValue: rejectStatus });
    }
    if (!status) return '–';
    return translate(`orders:${status.toUpperCase()}`, { defaultValue: status });
};

export const restorationTypeLabel = (translate: TFunction, type?: string | null) =>
    type ? translate(`orders:${type}`, { defaultValue: type }) : '–';
